var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 11.1783L15.2443 16.4223L16.4228 15.2438L11.1788 9.99978L16.4228 4.75574L15.2443 3.57723L10.0003 8.82127L4.75615 3.57715L3.57764 4.75566L8.82175 9.99978L3.57764 15.2439L4.75615 16.4224L10.0003 11.1783Z",
    fill: "#606060"
  })));
};
export { SvgClose as ReactComponent };
export default __webpack_public_path__ + "assets/9589933e.svg";